<template>
  <div class="DropMultiSelectFilterBox">
    <arkDropMultiSelectFilter
      :PropsData="propsData"
      :Url="url"
      :filterMode="true"
      v-model="dropValue"
      :http="network"
      :AutoRequest="sendAutoMessage"
      :TableRequest="sendTableMessage"
      @on-change="valueChange"
      @on-clear="clearFun"
      @on-keydown="keydownFun">
    </arkDropMultiSelectFilter>
  </div>
</template>

<script>
const { network } = R3;
export default {
  name: 'cusArkDropMultiSelectFilter',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    // 接口入参
    sendAutoMessage() {
      const sendAutoMessage = {
        colid: this.items.colid,
        fixedcolumns: this.items.fixedcolumns,
      };
      return sendAutoMessage;
    },
    propsData() {
      return {
        ...this.items,
        isBackRowItem: true,
        custom: true, // 绕过r3里被重写的组件方法'postTableData'
        single: true,
        className: `${this.items.colname}`,
        items: this.items,
        singleTurn: true,
        enterType: true,
        disabled: this.items.readonly && (this.items.webconf ? !this.items.webconf.ignoreDisableWhenEdit : true),
        hidecolumns: ['id', 'value'],
        placeholder: '',
        isShowPopTip: () => {
          /* const changeVal = vm.$store.state[R3.getModuleName()].updateData.PS_C_PRO.changeData.MODIFIERNAME
          const defaultVal = vm.$store.state[R3.getModuleName()].updateData.PS_C_PRO.default.PS_C_PRO.MODIFIERNAME
          const val = changeVal || defaultVal */
          const val = vm.$store.state.customize.commodityCategoryId
          if (!val) {
            this.$Message.warning('请先选择商品类目！')
            return false
          } else {
            this.sendTableMessage = {
              ...this.sendTableMessage,
              fixedcolumns: {
                'ATT_GROUP_TYPE': 2,
                'PS_C_CATEGORY_ID': val
              }
            }
            return true
          }
        }
      };
    },
  },
  data() {
    return {
      sendTableMessage: {
        isdroplistsearch: true,
        refcolid: 1700857466,
        fixedcolumns: null
      },
      items: {},
      dropValue: [],
      url: {
        autoUrl: '/p/cs/fuzzyquerybyak',
        tableUrl: '/p/cs/QueryList',
        tableSearchUrl: '/p/cs/newQueryList',
      },
      network: network,
    };
  },
  mounted() {
    /* window.addEventListener("notificationOfMain", ({ detail }) => {
      if (detail.hasOwnProperty('MODIFIERNAME')) {
        this.sendTableMessage = {
          ...this.sendTableMessage,
          fixedcolumns: {
            'ATT_GROUP_TYPE': 2,
            'PS_C_CATEGORY_ID': detail.MODIFIERNAME
          }
        }
      }
    }, false); */
    setTimeout(() => {
      this.items = this.$parent.$props.items;
      const val = this.$parent.$props.value;
      if (val) {
        // 详情，调queryList做回显
        const params = new FormData()
        const obj = {
          "table":"PS_C_SALES_INFO",
          "startindex":0,
          "range":20,
          "fixedcolumns":{
            "ID": val
          },
          "column_include_uicontroller":true,
          "isolr":false
        }
        params.append('searchdata', JSON.stringify(obj))
        this.service.common.publicUrlParams('/p/cs/QueryList', params).then(res => {
          if (res.data.code == 0 && res.data.datas && res.data.datas.row) {
            const Label = res.data.datas.row[0].ENAME.val
            this.dropValue = [
              { ID: val, Label }
            ]
          }
        })
      }
    }, 1);
  },
  methods: {
    /**
     * 改变值的事件
     * @param v
     */
    valueChange(v) {
      console.log('valueChange::', v)
      if (v && v[0].ID) {
        this.dropValue = [
          {
            ID: v[0].ID,
            Label: v[0].rowItem.ATT_NAME_ID.val
          }
        ]
        this.$emit('change', v[0].rowItem.ATT_NAME_ID.refobjid.toString(), this);
      }
    },
    /**
     * 清除数据触发
     * @param v
     */
    clearFun() {
      this.dropValue = [
        { ID: '', Label: '' }
      ]
      this.$emit('change', '', this);
    },
    keydownFun(v) {
      if (this.items.keydownFun) {
        this.items.keydownFun(v);
      }
    },
  },
};
</script>

<style  lang="less">
.DropMultiSelectFilterBox {
  .ark-fkrp-select-icon {
    height: 100%;
    top: 0;
  }
}
</style>
